import React, { useState } from 'react';
import { Row, Col} from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import Picker from '../../../../Common/Picker';
import CValidator from '../../../../Common/CValidator';
import List from "../../../../Templates/List"
import { Dropdown } from '@fluentui/react';
import ListPagination from '../../../../Templates/List/ListPagination';
import { _global_buttonStyles } from '../../../../../common/ObjectStructures/Trasnversal';
import PropTypes from 'prop-types';
import MessageBox from '../../../../Common/Message/MessageBox';
import { __MessageTypes } from '../../../../../common/Dictionaries';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../../common/Helpers';
import MainAppContext from '../../../../../MainAppContext';
import { useContext } from 'react';
import { useGetPrivilegeRolesElementsDropDown, useGetPrivilegePartyMembers, useGetPrivilegePartys } from '../../../../../hooks/services/sPrivilege/useOfPrivilege';
import { useGetUsersByElementId } from '../../../../../hooks/services/_Transversal/useOfTransversal';
import { addListPrivilegePartyMember, deletePrivilegePartyMember, updatePrivilegePartyMember } from '../../../../../services/sPrivilege/privilege.service';

const SidePanelRolesProfiles = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
  
    const { 
        inputParam_IsPanelOpen = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_EditMode = null,
        inputParam_Element = null,
        inputParam_OnUpdateElementRoleCount = null,
        inputParam_ElementType = null,
        inputParam_GridSetterEnabled = false,
    } = props;

    const buttonAddStyles = { root: { float: "right" } };
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const [partyPrivilege, setPartyPrivilege] = useState(null);
    useGetPrivilegePartys(inputParam_Element.id, partyPrivilege, setPartyPrivilege, inputParam_IsPanelOpen);
    
    const [auxElementUserList, setAuxElementUserList] = useState(null);
    const [elementUserList, setElementUserList] = useState(null);
    useGetUsersByElementId(inputParam_Element.id, elementUserList, setElementUserList, false, [], inputParam_IsPanelOpen, false, true);

    const [selectedElementRole, setSelectedElementRole] = useState(null);
    const [elementRoleList, setElementRoleList] = useState(null);
    const [auxElementRoleList, setAuxElementRoleList] = useState(null);
    const onClickRole = (itemId) => {
        let obj = elementRoleList.find(element => element.id === itemId);
        if (obj !== undefined) { 
            obj.selected = true
            setSelectedElementRole(obj)
        };

        setIsValidForm(prevState => ({
            ...prevState,
            hasRole: obj !== undefined,
        }));

        setAuxElementRoleList(auxElementRoleList)
    }
    useGetPrivilegeRolesElementsDropDown(inputParam_Element.id, elementRoleList, setElementRoleList, inputParam_IsPanelOpen);

    const [clienCandidateUserList, setClientCandidateUserList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
    const [basePrivilegeUserList, setBasePrivilegeUserList] = useState(null);
    useGetPrivilegePartyMembers(inputParam_Element.id, clienCandidateUserList.data, setClientCandidateUserList, setBasePrivilegeUserList, inputParam_IsPanelOpen)

    const [isValidForm, setIsValidForm] = useState({hasUsers: null, hasPartyType: null, hasRole: null});


    const [selectedPickerUsers, setSelectedPickerUsers] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});
    const [itemToDelete, setItemToDelete] = useState(null);
    const [itemToEdit, setItemToEdit] = useState(null);

    const validateFormControls = (list) => {

        const isValidObject = {
            hasUsers: selectedPickerUsers.data !== null && selectedPickerUsers.data.length > 0,
            hasPartyType: partyPrivilege.filter(x => x.selected).length > 0,
            hasRole: selectedElementRole !== null,
        }

        setIsValidForm(isValidObject);
    
        return isValidObject.hasPartyType && isValidObject.hasRole && isValidObject.hasUsers;
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);

        setIsValidForm({hasUsers: null, hasPartyType: null, hasRole: null});

        showMessage(setMessageConfig, false, null, null)
        
        const usersToPreserve = []
        if (clienCandidateUserList.data !== null) {
            clienCandidateUserList.data.forEach(element => {
                if (element.id !== null && element.id !== 0) {
                    usersToPreserve.push(element);
                }
            });
        }

        setClientCandidateUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: usersToPreserve
        }));
    };

    const onSaveUsers = () => {
        let usersToSave = [];

        clienCandidateUserList.data.forEach(member => {
                usersToSave.push({
                    id: member.id <= 0 ? 0 : member.id,
                    elementPartyId: member.elementPartyId,
                    partyName: member.partyName,
                    privilegeRoleId: parseInt(member.privilegeRoleId),
                    roleName: member.roleName,
                    username: member.username,
                    fullname: member.fullname,
                    userAuthProfileId: member.userAuthProfileId !== null && member.userAuthProfileId !== undefined ? member.userAuthProfileId : 0,
                    deactivate: false
                })
        });

        const validUsersToSave = usersToSave.filter(u =>
            u.userAuthProfileId > 0 &&
            u.elementPartyId > 0 &&
            parseInt(u.privilegeRoleId) > 0
        );

        if (validUsersToSave.length === 0 && usersToSave.length > 0) {
            return;
        }

        addListPrivilegePartyMember(inputParam_Element.id, validUsersToSave).then((response) => {
            if (response.data.succeeded) {
                setClientCandidateUserList(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: null
                }));

                setSelectedPickerUsers(prevState => ({
                    ...prevState,
                    data: null
                }));

                setAuxElementRoleList(auxElementRoleList.map(item => { item.selected = false; return item; }))
                setPartyPrivilege(partyPrivilege.map(item => { item.selected = false; return item; }))
                setElementUserList(null);
                
                inputParam_OnUpdateElementRoleCount && inputParam_OnUpdateElementRoleCount(usersToSave.length)

                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
        setClientCandidateUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: null
        }));
        setSelectedPickerUsers(prevState => ({
            ...prevState,
            data: null
        }));
    };
    
    const onClosePanel = () => {
        //##No deberia ser necesario dejar en null para que obtenga nuevamente los usuarios. Esto dado que los usuarios del cliente no deberian vairar.
        //##Pero si se quire, podemos descomentar esta linea para que cada vez que se seleccione "Seleccionar usuarios" en las card, se busquen los usuarios en el sistema.
        //##setClientCandidateUserList(null);
        onDismissPanel();
    };

    const onChangeUser = (currentNode, selectedNodes) => {
        setSelectedPickerUsers(prevState => ({
            ...prevState,
            data: selectedNodes
        }));

        auxElementUserList.forEach(x => {
            x.checked = x.userName === currentNode.userName ? currentNode.checked : x.checked;
        })

        setAuxElementUserList(auxElementUserList);
                
        setIsValidForm(prevState => ({
            ...prevState,
            hasUsers: auxElementUserList.filter(x => x.checked).length > 0
        }));
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium-paginnation d-none">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="boardElementRoleSelection"
                            data={ clienCandidateUserList }
                            setData={ setClientCandidateUserList } />
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            inputParam_EditMode && clienCandidateUserList.data && clienCandidateUserList.data.length > 0 && (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) &&
                            <PrimaryButton onClick={ onSaveUsers } styles={_global_buttonStyles}>{t('data-lang-btn-save')}</PrimaryButton>
                        }
                        <DefaultButton onClick={onClosePanel}>{t('data-lang-btn-close')}</DefaultButton>
                    </Col>
                </Row>
    }

    const onAddUserToUserList = () => {
        if (validateFormControls()) {
            let idFlyItems = clienCandidateUserList.data.length > 0 ? clienCandidateUserList.data.reduce(function(prev, curr) {
                return parseInt(prev.id) < parseInt(curr.id) ? prev : curr;
            }) : null;
            const elementParty = partyPrivilege.find(x => x.selected);
            const elementRole = selectedElementRole;

            for (let index = 0; index < selectedPickerUsers.data.length; index++) { 
                let _aux_index = index + 1;

                let element = selectedPickerUsers.data[index]
                let aux_index = idFlyItems !== null ? ((parseInt(idFlyItems.id) > 0)? _aux_index : parseInt(idFlyItems.id - _aux_index)) : 1;

                let duplicated = clienCandidateUserList.data.find(x => x.username === element.userName && x.roleName == elementRole.name);

                if(duplicated === null || duplicated === undefined) {
                    clienCandidateUserList.data.push({
                        id: aux_index * -1,
                        elementId: inputParam_Element.id,
                        privilegeRoleId: elementRole.id,
                        elementPartyId: elementParty.id,
                        partyName: elementParty.name,
                        userAuthProfileId: element.id,
                        roleName: elementRole.name,
                        username: element.userName,
                        fullname: element.fullName,
                        emailUser: element.emailUser,
                        deactivate: false,
                    });
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-someitemsalredyexist'))
                }
            }            

            setClientCandidateUserList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: clienCandidateUserList.data
            }));
            
            setSelectedPickerUsers(prevState => ({
                ...prevState,
                data: null
            }));

            auxElementUserList.map(x => x.checked = false)
            setAuxElementUserList(auxElementUserList);

            setIsValidForm({hasUsers: null, hasPartyType: null, hasRole: null});
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    }

    const onDeleteUserFromListClick = (item) => {
        if (item.id > 0) {
            deletePrivilegePartyMember(item.id).then((response) => {
                if (response.data.succeeded) {
                    let newUserList = [];

                    clienCandidateUserList.data.forEach(obj => {
                        if (obj.id !== item.id) {
                            newUserList.push(obj)
                        }
                    })
                        
                    setClientCandidateUserList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: newUserList
                    }));

                    inputParam_OnUpdateElementRoleCount && inputParam_OnUpdateElementRoleCount(newUserList.length)

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            let newUserList = [];

            clienCandidateUserList.data.forEach(obj => {
                if (obj.username !== item.username) {
                    newUserList.push(obj)
                }
            })

            setClientCandidateUserList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: newUserList
            }));
        }
    }

    const onCancelRowClick = (item) => {
        const objPrivilege = basePrivilegeUserList.find(x => x.id === item.id);

        if (objPrivilege !== undefined && objPrivilege !== null) {
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))

            clienCandidateUserList.data.forEach(element => {
                if (item.id === element.id) {
                    element.privilegeRoleId = objPrivilege.privilegeRoleId;
                }
            });
    
            setClientCandidateUserList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: clienCandidateUserList.data
            }));
    
            ManipulateRowButtonsDisplay(item.id);
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        }
    };

    const onEditUserFromListClick = (item, setItemToEdit) => {
        //Cambiar clase de cell para que se habilite control textbox.
        ManipulateRowButtonsDisplay(item.id)
    }

    const ManipulateRowButtonsDisplay = (itemId) => {
        let elementsRowView = document.getElementsByClassName(`rowView${itemId}`);
        let elementsRowEdit = document.getElementsByClassName(`rowEdit${itemId}`);
        let elementBtnMantSave = document.getElementById(`btnMantSave${itemId}`);
        let elementBtnMantEdit = document.getElementById(`btnMantEdit${itemId}`);
        let elementBtnMantCancel = document.getElementById(`btnMantCancel${itemId}`);
        
        const isHiddenItem = elementsRowView[0].style.display === "none";

        if (isHiddenItem) {
            Array.prototype.forEach.call(elementsRowView, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "block"; }
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "none"; }
            });

            elementBtnMantSave.style.display = "none";
            elementBtnMantCancel.style.display = "none";
            elementBtnMantEdit.style.display = "block";
        }
        else {
            Array.prototype.forEach.call(elementsRowView, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "none"; }
            });
            Array.prototype.forEach.call(elementsRowEdit, function(el) {
                const isHiddenItem = el.style.display === "none";
                if (isHiddenItem) { el.style.display = "block"; }
                else { el.style.display = "block"; }
            });

            elementBtnMantSave.style.display = "block";
            elementBtnMantCancel.style.display = "block";
            elementBtnMantEdit.style.display = "none";
        }
    }

    const onChangeRoleType = (ev, item) => {
        for (let index = 0; index < clienCandidateUserList.data.length; index++) {
            const element = clienCandidateUserList.data[index];
            if (ev.target.id.indexOf(`ddlType${element.id}`) !== -1) {
                element["privilegeRoleId"] = item.key
            }
        }

        setClientCandidateUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: clienCandidateUserList.data
        }));

        setIsValidForm(prevState => ({
            ...prevState,
            hasRole: !isNullUndefinedOrEmpty(item.key)
        }));
    }

    const onChangePartyType = (ev, item) => {
        for (let index = 0; index < partyPrivilege.length; index++) {
            const element = partyPrivilege[index];
            element.selected = (element.id === item.id)
        }

        const selectedParty = partyPrivilege.find(x => x.id === item.id);

        if(selectedParty.manager === true) {
            const internalRoles = elementRoleList.filter(x => x.isExternal === false || x.id === 0);
            setAuxElementRoleList(internalRoles);

            const internalUsers = elementUserList.filter(x => x.legalEntityTypeId !== 3);
            setAuxElementUserList(internalUsers);
        }
        else if (selectedParty.manager === false) {
            const externalRoles = elementRoleList.filter(x => x.isExternal === true || x.id === 0);
            setAuxElementRoleList(externalRoles);

            const externalUsers = elementUserList.filter(x => x.legalEntityTypeId === 3);
            setAuxElementUserList(externalUsers);
        }

        setPartyPrivilege(partyPrivilege);
        setSelectedElementRole(null);
        setSelectedPickerUsers({fireUpdate: true, data: null, pageNumber: 1, pageSize: 1000, filters: []});

        setIsValidForm(prevState => ({
            ...prevState,
            hasPartyType: !isNullUndefinedOrEmpty(item.key)
        }));
    }

    const onSaveRowClick = (item) => {
        const newObj = 
        {
            id: item.id,
            elementPartyId: item.elementPartyId,
            privilegeRoleId: parseInt(item.privilegeRoleId),
            username: item.username,
            userAuthProfileId: item.userAuthProfileId !== null && item.userAuthProfileId !== undefined ? item.userAuthProfileId : 0,
            deactivate: false
        }

        if (item.id > 0) {
            updatePrivilegePartyMember(item.id, newObj).then((response) => {
                //No se elimina desde listado ya que esto lo hace #CUSTOMDELETE# (Buscar en este archivo).
                //De lo contrario tendría dos cosas iguales.
                if (response.data.succeeded) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    setItemToEdit(item);
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            setItemToEdit(item);
        }
    }

    //Por alguna razon el evento click que deberia borrar no funciona, no obtiene el valor de la lista de clientes, la obtiene con el valor inicial, que es nula.
    //Esta fue la unica forma en la que se pudo borrar el item. Posiblemente se vea en otros lugares esta misma implementacion. Buscar por #CUSTOMDELETE#
    // if (itemToDelete !== null) {
    //     let newUserList = [];

    //     clienCandidateUserList.data.forEach(obj => {
    //         if (obj.username !== itemToDelete.username) {
    //             newUserList.push(obj)
    //         }
    //     })

    //     setClientCandidateUserList(prevState => ({
    //         ...prevState,
    //         fireUpdate: true,
    //         data: newUserList
    //     }));
        
    //     //inputParam_OnUpdateElementRoleCount && inputParam_OnUpdateElementRoleCount(newUserList);
        
    //     setItemToDelete(null);
    // }

    if (itemToEdit !== null) {
        clienCandidateUserList.data.forEach(obj => {
            if (obj.username === itemToEdit.username && obj.id === itemToEdit.id) {
                obj.privilegeRoleId = itemToEdit.privilegeRoleId
                obj.roleName = elementRoleList.find(x => x.id === itemToEdit.privilegeRoleId).name
                
                ManipulateRowButtonsDisplay(itemToEdit.id)
            }
        })

        setClientCandidateUserList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: clienCandidateUserList.data
        }));

        setItemToEdit(null);
    }
    
    

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ `${t('data-lang-lbl-roles')} - ${inputParam_Element.name}` }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                type={PanelType.custom}
                customWidth="780px"
            >
                {
                    inputParam_EditMode === true && elementRoleList && (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) &&
                    <>
                        <Row className="pt-3">
                            {
                                partyPrivilege !== null && partyPrivilege.length > 0 && partyPrivilege.length !== 1 &&
                                <Col>
                                    <Dropdown
                                        label={t('data-lang-lbl-party')}
                                        options={partyPrivilege}
                                        onChange={onChangePartyType}
                                    />
                                    {
                                        isValidForm.hasPartyType !== null &&
                                        <CValidator isInValid={ !isValidForm.hasPartyType } />
                                    }
                                </Col>
                            }
                            <Col>
                                <Dropdown
                                    label={t('data-lang-lbl-role')}
                                    options={!isNullUndefined(auxElementRoleList) ? auxElementRoleList : []}
                                    selectedKey={selectedElementRole ? selectedElementRole.id : null}
                                    onRenderOption={(option) => <div className="cursor-pointer" onClick={() => onClickRole(option.id)}>
                                        {
                                            !isNullOrEmpty(option.description) ?
                                            <div><b>{option.name}</b></div> : <div>{option.name}</div>
                                        }
                                        {
                                            !isNullOrEmpty(option.description) &&
                                            <div>{option.description}</div>
                                        }
                                    </div>}
                                />
                                {
                                    isValidForm.hasRole !== null &&
                                    <CValidator isInValid={ !isValidForm.hasRole } />
                                }
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <Picker
                                    data={ auxElementUserList !== null ? auxElementUserList : [] }
                                    mode="multiSelect"
                                    className="dropdown-checkbox remove-position"
                                    isInValid={ !isValidForm.hasUsers }
                                    texts={{ placeholder: t('data-lang-lbl-chooses') }}
                                    onChange={ onChangeUser }
                                    labelText={ t('data-lang-lbl-users') }
                                    refresh={true}
                                />
                                {
                                    isValidForm.hasUsers !== null &&
                                    <CValidator isInValid={ !isValidForm.hasUsers } />
                                }
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <PrimaryButton onClick={ onAddUserToUserList } styles={buttonAddStyles}>{t('data-lang-btn-add')}</PrimaryButton>
                            </Col>
                        </Row>
                    </>
                }
                <Row className="pt-5 mt-4">
                    <Col>
                    {
                        elementRoleList && elementUserList && partyPrivilege &&
                        <List
                            listLocalStoragePageSizeVariableName="boardElementRoleSelection"
                            manipulateLocalData={ true }
                            setData={setClientCandidateUserList}
                            showHeaders={false}
                            data={clienCandidateUserList}
                            columns={[
                                {
                                    key: 'username',
                                    name: t('data-lang-lbl-username'),
                                    fieldName: 'username',
                                    minWidth: 200,
                                    maxWidth: 200,
                                    onRender:(item) => {
                                        let user = elementUserList !== null ? elementUserList.find(x => x.userName === item.username) : null
                                        return <> 
                                            {
                                                user &&
                                                <div title={user.emailUser}>{ user === undefined ? item.fullname : user.fullName }</div>
                                            }
                                            {
                                                !user &&
                                                <div>{ item.fullname }</div>
                                            }
                                        </>
                                    }
                                },
                                {
                                    key: 'partyName',
                                    name: t('data-lang-lbl-party'),
                                    fieldName: 'partyName',
                                    minWidth: 150,
                                    maxWidth: 150,
                                    onRender:(item) => {
                                        return <div>{ item.partyName }</div>
                                    }
                                },
                                {
                                    key: 'roleName',
                                    name: t('data-lang-lbl-role'),
                                    fieldName: 'roleName',
                                    minWidth: 200,
                                    maxWidth: 200,
                                    onRender:(item) => {
                                        const currentItemParty = partyPrivilege.find(x => x.id === item.elementPartyId);

                                        let _options = (elementRoleList !== null && currentItemParty !== undefined) ? elementRoleList.filter(x => currentItemParty.manager === true ? x.isExternal === false : x.isExternal === true) : [];

                                        _options.map(x => {
                                            x.key = x.id;
                                            x.text = x.name;
                                            x.title = x.name;
                                        })

                                        let obj = elementRoleList.find(x => x.id === item.privilegeRoleId)

                                        return  <>
                                                    <Row className={`ps-2`}>
                                                        <Col className={`rowView${item.id}`} style={ {display: "block"} }>
                                                            <div>{ obj !== undefined && obj !== null ? obj.name : "" }</div>
                                                        </Col>
                                                        <Col className={`rowEdit${item.id}`} style={ {display: "none"} }>
                                                            <Dropdown
                                                                id={`ddlType${item.id}`}
                                                                placeholder={t('data-lang-placeholder-selectoption')}
                                                                options={
                                                                    _options
                                                                }
                                                                selectedKey={ item.privilegeRoleId }
                                                                onChange={ onChangeRoleType }
                                                                styles={ {title: { height: "27px" }} }
                                                                className="pt-1"
                                                                errorMessage={ t('data-lang-msg-required') }
                                                                required={true}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </>
                                    }
                                },
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'username',
                                    //minWidth: "10%",
                                    //maxWidth: "10%",
                                    onRender:(item, row) => {
                                        return  <>
                                                {
                                                    inputParam_EditMode === true &&<div className='d-flex'>           
                                                        {
                                                            item.id > 0 && 
                                                            <>
                                                                <ActionButton id={`btnMantEdit${item.id}`} iconProps={{ iconName: 'Edit' }} onClick={() => onEditUserFromListClick(item, setItemToDelete)} allowDisabledFocus >
                                                                </ActionButton>
                                                                <ActionButton id={`btnMantCancel${item.id}`} style={{display: "none"}} iconProps={{ iconName: 'Cancel' }} onClick={() => onCancelRowClick(item)} allowDisabledFocus >
                                                                </ActionButton>
                                                                <ActionButton id={`btnMantSave${item.id}`} style={{display: "none"}} iconProps={{ iconName: 'Save' }} onClick={() => onSaveRowClick(item)} allowDisabledFocus >
                                                                </ActionButton> 
                                                            </>
                                                        }
                                                        <ActionButton id={`btnMantDelete${item.id}`} iconProps={{ iconName: 'Delete' }} onClick={() => onDeleteUserFromListClick(item)} allowDisabledFocus >
                                                        </ActionButton>
                                                    </div>
                                                }
                                                </>
                                    }
                                }
                            ].filter(x => (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) ? true : x.key !== "id" )}
                        />
                    }
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelRolesProfiles.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_Element: PropTypes.object.isRequired,
    inputParam_OnUpdateElementRoleCount: PropTypes.func.isRequired,
    inputParam_ElementType: PropTypes.number,
};

export default SidePanelRolesProfiles;